/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
interface HeaderHomeProps {
  data: any | ""; // you can replace `any` with a proper type if you know the shape
  loading: boolean | false;
}
const Nav: React.FC<HeaderHomeProps> = ({ data, loading }: any) => {
  if (loading) return <p>Loading...</p>;
  // // if (error) return <p>Error: {error}</p>;
  // if (!data) return <p>No data found.</p>;
 
 // Extract URL safely
  const custaurl = data?.field_link_url?.[1]?.uri ? data?.field_link_url?.[1]?.uri?.replace('internal:', '')?.trim() : "#";


    // eslint-disable-next-line react-hooks/rules-of-hooks
    const buttonRef = useRef<HTMLElement | null>(null); // <-- HTMLElement for <i> tag
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [active, setActive] = useState("home");

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const button = buttonRef.current;
    if (!button) return;

    const mobileNavToggle = () => {
      document.body.classList.toggle("mobile-nav-active");

      // Toggle between bi-list and bi-x
      if (button.classList.contains("bi-list")) {
        button.classList.remove("bi-list");
        button.classList.add("bi-x");
      } else {
        button.classList.remove("bi-x");
        button.classList.add("bi-list");
      }
    };

    button.addEventListener("click", mobileNavToggle);

    return () => {
      button.removeEventListener("click", mobileNavToggle);
    };
  }, []);


// // eslint-disable-next-line react-hooks/rules-of-hooks
// const [open, setOpen] = useState(true);
// // eslint-disable-next-line react-hooks/rules-of-hooks
// const [activated, setActivated] = useState(false);

 
//   // First click
//   const handleClick = () => {
//     setOpen(!open);
//     setActivated(true); // enable hover after first click
//   };

// const handleMouseEnter = () => {
//   setOpen(true);
// };
//   const handleMouseLeave = () => {
//     if (activated) setOpen(false);
//   };


  // Close menu when nav link clicked
  const handleNavLinkClick = (section: string) => {
    setActive(section);
    if (document.body.classList.contains("mobile-nav-active")) {
      document.body.classList.remove("mobile-nav-active");

      // Reset icon to bi-list
      const button = buttonRef.current;
      if (button) {
        button.classList.add("bi-list");
        button.classList.remove("bi-x");
      }
    }
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [open, setOpen] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isDesktop, setIsDesktop] = useState(false);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 992px)");

    const handleResize = () => {
      setIsDesktop(mediaQuery.matches);
    };

    handleResize(); // initial check
    mediaQuery.addEventListener("change", handleResize);

    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  // Desktop hover
  const handleMouseEnter = () => {
    if (isDesktop) setOpen(true);
  };

  const handleMouseLeave = () => {
    if (isDesktop) setOpen(false);
  };

  // Mobile click
  const handleClick = () => {
    if (!isDesktop) setOpen(!open);
  };

  return (
          <nav id="navmenu" className="navmenu ms-auto me-md-3 float-sm-end" >
             <ul >
                 <li>  <NavLink to="/"
                 className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')} onClick={() => handleNavLinkClick('home')} > Home </NavLink></li>
                 <li>  <NavLink to="/about-us"
                 className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')} onClick={() => handleNavLinkClick('about')} > About Us </NavLink></li>
                 <li>  <NavLink to="/solutions"
                 className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')} onClick={() => handleNavLinkClick('solution')} > Solutions </NavLink></li>
                 <li>  <NavLink to="/gro-one-app"
                 className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}  onClick={() => handleNavLinkClick('gro-one-app')} > Gro one app </NavLink></li>
                 <li >  <NavLink to="/investors"
                 className={({ isActive }) => (isActive ? 'nav-item active ' : 'nav-item ')} onClick={() => handleNavLinkClick('investor')} > Investor </NavLink></li>
                 <li>  <NavLink to="/resources"
                 className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')} onClick={() => handleNavLinkClick('resources')}> Resources </NavLink></li>
                 <li>  <NavLink to="/careers"
                 className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}  onClick={() => handleNavLinkClick('career')}> Careers </NavLink></li>
                 <li>  <NavLink to="/contact-us"
                 className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')} onClick={() => handleNavLinkClick('contact')}> Contact Us </NavLink></li>
                 <li className={`dropdown custdropdown ${open ? "open" : ""}`}  onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave} >
                      <a    onClick={handleClick}><span>Customer login</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                      {open && (
                      <ul>
                          <li><a href="https://teadmin.letsgro.co/login/partner" title="https://teadmin.letsgro.co/login/partner" target="_blank">Gro Loads</a></li>
                          <li><a href="https://track.letsgro.co/auth/login" title="https://track.letsgro.co/auth/login" target="_blank">Gro Fleet</a></li>
                          <li><a href="https://rfq.letsgro.co/auth/login" title="https://rfq.letsgro.co/auth/login" target="_blank">Gro RFQ</a></li>
                      </ul>
                        )}
                  </li>
                    
                  {/* <li className='d-md-none d-lg-none d-sm-block w-100 ' ><a className="nav-item "  target='_black' href={custaurl} title={custaurl} ><span className="btn btn-md w-100 btn-success">{data?.field_link_url?.[1]?.title ? data?.field_link_url?.[1]?.title : ''}</span></a></li>  */}
                {/* <li className='d-md-none d-lg-none d-none w-100 ' ><a className="nav-item "  target='_black' href={custaurl} title={custaurl} ><span className="btn btn-md w-100 btn-success">{data?.field_link_url?.[1]?.title ? data?.field_link_url?.[1]?.title : ''}</span></a></li>  */}
              </ul>
              {/* <ul>
                  <li><a href="/" className={`nav-item ${active === 'home' ? 'active' : ''}`}
        onClick={() => setActive('home')}>Home</a></li>
                  <li><a href="/about" className={`nav-item ${active === 'about' ? 'active' : ''}`}
        onClick={() => setActive('about')}>About us</a></li>
                  <li><a href="/solution" className={`nav-item ${active === 'solution' ? 'active' : ''}`}
        onClick={() => setActive('solution')}>Solutions</a></li>
                  <li><a href="/gro-one-app" className={`nav-item ${active === 'gro-one-app' ? 'active' : ''}`}
        onClick={() => setActive('gro-one-app')}>Gro One App</a></li>
                  <li><a href="#">Investor</a></li>
                  <li><a href="/media" className={`nav-item ${active === 'media' ? 'active' : ''}`}
        onClick={() => setActive('media')}>Media</a></li>
                  <li className="dropdown d-none">
                      <a href="#"><span>Insights</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                      <ul>
                          <li><a href="#">Dropdown 1</a></li>
                          <li className="dropdown">
                              <a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                              <ul>
                                  <li><a href="#">Deep Dropdown 1</a></li>
                                  <li><a href="#">Deep Dropdown 2</a></li>
                                  <li><a href="#">Deep Dropdown 3</a></li>
                                  <li><a href="#">Deep Dropdown 4</a></li>
                                  <li><a href="#">Deep Dropdown 5</a></li>
                              </ul>
                          </li>
                          <li><a href="#">Dropdown 2</a></li>
                          <li><a href="#">Dropdown 3</a></li>
                          <li><a href="#">Dropdown 4</a></li>
                      </ul>
                  </li>
                  <li><a href="/career" className={`nav-item ${active === 'career' ? 'active' : ''}`}
        onClick={() => setActive('career')}>Career</a></li>
                  <li><a href="/contact" className={`nav-item ${active === 'contact' ? 'active' : ''}`}
        onClick={() => setActive('contact')}>Contact</a></li>
              </ul> */}
              <i ref={buttonRef} className="mobile-nav-toggle d-xl-none bi bi-list "></i>
                {/* <i  className={`mobile-nav-toggle d-xl-none ${isMobileNavActive ? "bi-x" : "bi-list"}`}
        onClick={handleMobileNavToggle}></i> */}
               
          </nav>
  );
};

export default Nav;